export const LANDING_PAGE_APARTMENT =
  'https://pulse.insure/insurance-flat-info/';
export const LANDING_PAGE_HOUSE =
  'https://pulse.insure/insurance-property-info/';
export const LANDING_PAGE_PETS = 'https://pulse.insure/pets-info/';
export const LANDING_PAGE_SPORT = 'https://pulse.insure/sport-info/';
export const LANDING_PAGE_MITE = 'https://pulse.insure/mite-info/';
export const LANDING_PAGE_TRAVEL = 'https://pulse.insure/travel-info/';
export const RGS_PRODUCTS = 'https://rgs.online/main/';
export const RGS_RU = 'https://www.rgs.ru/';
